<template lang="pug">
    .functional-tests-block(:class="{'functional-tests-block--re-contact': isReContact, 'functional-tests-block--addition-only': additionOnly}")
        .functional-tests-block__row(
            v-for="(item, index) in functionalTests"
            :key="item.id"
            :class="{old: item.old}"
        )
            .row
                app-datepicker.functional-tests-block--date(
                    v-model="item.date"
                    label="Дата проведения"
                    :error="getFieldError(item, index, 'date')"
                )
                app-select.functional-tests-block--select(
                    v-model="item.test"
                    :options="testList"
                    searchable
                    label="Показатель"
                    :error="getFieldError(item, index, 'test')"
                )
                app-text-field.functional-tests-block--result(
                    v-model="item.result"
                    is-float-number
                    label="Результат"
                    :error="getFieldError(item, index, 'result')"
                )
                .app-choice-group.functional-tests-block--test-result
                    .app-choice-group__label Результат
                    .app-choice-group__list
                        app-choice(
                            v-model="item.testResult"
                            type="radio"
                            label="Нет"
                            :radio-value="0"
                            :disabled="additionOnly"
                        )
                        app-choice(
                            v-model="item.testResult"
                            type="radio"
                            label="Да"
                            :radio-value="1"
                            :disabled="additionOnly"
                        )
                app-text-field.functional-tests-block--note(
                    v-if="item.testResult"
                    v-model="item.note"
                    label="Заметки"
                )
                app-dropper(
                    :class="{hidden: (isReContact || additionOnly) && item.old}"
                    @click="dropFunctionalTest(index)"
                )
            hr.narrow(v-if="index < functionalTests.length - 1")
        .br
        app-button(
            plus
            @click="addNewFunctionalTest"
        ) Добавить
</template>

<script>
import { uniqueId } from 'lodash';
import { required } from 'vuelidate/lib/validators';
import moment from 'moment';

export default {
    name: 'functional-tests-block',

    props: {
        value: {
            type: Array,
            required: true,
        },

        isReContact: {
            type: Boolean,
            required: false,
            default: false,
        },

        additionOnly: {
            type: Boolean,
            required: false,
            default: false,
        },
    },

    data: () => ({
        functionalTests: [],
    }),

    validations: {
        functionalTests: {
            $each: {
                date: { required },
                test: { required },
                result: { required },
            },
        },
    },

    computed: {
        testList(){
            return this.$store.getters.functionalTests;
        },
    },

    watch: {
        functionalTests(value) {
            this.$emit('input', value);
        },
    },

    mounted() {
        this.$nextTick(() => {
            this.functionalTests = this.value;
        });
    },

    methods: {
        addNewFunctionalTest() {
            this.functionalTests.push({
                id: uniqueId(),
                date: '',
                test: '',
                result: '',
                testResult: 0,
                note: '',
            });
            this.$v.$reset();
        },

        dropFunctionalTest(index) {
            this.$confirm({
                message: `Вы действительно хотите удалить тест?`,
                button: {
                    no: 'Нет',
                    yes: 'Да',
                },
                callback: confirm => {
                    if (confirm) {
                        this.functionalTests = this.functionalTests.filter((d, i) => i !== index);
                    }
                },
            });
        },

        getFieldError(item, index, field) {
            if (this.$v.functionalTests.$each.$iter[index].$dirty && !this.$v.functionalTests.$each.$iter[index][field].required) {
                return 'Заполните поле';
            }
            return null;
        },

        getFieldsForSave() {
            return this.functionalTests.map(d => {
                return {
                    date_at: moment(d.date).format('YYYY-MM-DD'),
                    functional_test_id: d.test.id,
                    result: d.result,
                    test_result: d.testResult,
                    note: d.testResult ? d.note : '',
                };
            });
        },

        getFormattedSavedFields(functionalTests) {
            let fields = functionalTests.map(d => ({
                id: d.id,
                date: +moment(d.date_at),
                test: d.functional_test,
                result: d.result,
                testResult: d.test_result,
                note: d.note || '',
                old: true,
            }));
            fields.sort((f1, f2) => f1.date - f2.date);
            return fields;
        },
    },
};
</script>

<style lang="scss">
.functional-tests-block {
    .functional-tests-block {
        &--date {
            width: rem(200px);
        }

        &--select {
            width: rem(438px);
        }

        &--result {
            width: rem(105px);
        }

        &--note {
            width: rem(294px);
        }
    }

    &--re-contact {
        .functional-tests-block__row.old {
            display: none;
        }
    }

    &--addition-only {
        .functional-tests-block__row.old {
            .app-text-field, .app-select, .app-datepicker {
                opacity: 0.5;

                pointer-events: none;
            }
        }
    }

    @include mobile_or_P {
        .functional-tests-block {
            &--date,
            &--select,
            &--result,
            &--test-result,
            &--note {
                width: 100%;
            }
        }
    }
}
</style>
